/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_Partner_MismatchInputs */

const es_co2_error_passkey_partner_mismatch = /** @type {(inputs: Error_Passkey_Partner_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La llave no corresponde a este aliado.`)
};

/**

* @param {Error_Passkey_Partner_MismatchInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_partner_mismatch = /** @type {((inputs?: Error_Passkey_Partner_MismatchInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Partner_MismatchInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_partner_mismatch(inputs)
});